import {createGlobalContext} from "@acng/frontend-relativity";
import {authUser} from "acng/core/service/env.js";

/**
 * @type {import("@acng/frontend-relativity").Context<?import("acng/core/service/env").AuthUserData>}
 */
export const ctxAuthUser = createGlobalContext(authUser);
